export const GET_TRAINING_HOSPITALS = 'GET_TRAINING_HOSPITALS';
export const CLEAR_TRAINING_HOSPITALS = 'CLEAR_TRAINING_HOSPITALS';

export const TRAINING_HOSPITAL_MAX_FETCH_NUM = 100;
